export function formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!date) return ''
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')
  const seconds = String(d.getSeconds()).padStart(2, '0')
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds)
}

export function formatDateShort(date) {
  return formatDate(date, 'YYYY-MM-DD')
}

export function formatTime(date) {
  return formatDate(date, 'HH:mm:ss')
}

export function formatDateTime(date) {
  return formatDate(date, 'YYYY-MM-DD HH:mm')
}

export function getToday() {
  return formatDate(new Date(), 'YYYY-MM-DD')
}

export function getYesterday() {
  const d = new Date()
  d.setDate(d.getDate() - 1)
  return formatDate(d, 'YYYY-MM-DD')
}

export function getWeekStart() {
  const d = new Date()
  const day = d.getDay()
  const diff = d.getDate() - day + (day === 0 ? -6 : 1)
  const monday = new Date(d.setDate(diff))
  return formatDate(monday, 'YYYY-MM-DD')
}

export function getMonthStart() {
  const d = new Date()
  return formatDate(new Date(d.getFullYear(), d.getMonth(), 1), 'YYYY-MM-DD')
}

export function getYearStart() {
  const d = new Date()
  return formatDate(new Date(d.getFullYear(), 0, 1), 'YYYY-MM-DD')
}